<script setup lang="ts">
import { RouterView } from 'vue-router'
import BottomTabBar from '@/components/layout/BottomTabBar.vue'
</script>

<template>
  <main class="min-h-dvh bg-bg-base text-text-hi mx-auto max-w-[460px] relative">
    <RouterView v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <BottomTabBar />
  </main>
</template>
